// @flow

import * as React from 'react';
import styled from '@emotion/styled';
import Slider from 'rc-slider';
import colorUtils from 'color';

type Props = {
  disabled?: boolean,
  min: number,
  max: number,
  onChange: number => void,
  value: number
};

const StyledSlider = styled(Slider)(
  ({ theme }) => ({
    '&.rc-slider': {
      padding: '6px 0'
    },
    '&.rc-slider-disabled': {
      background: 'none',
      opacity: 0.4
    },
    '& .rc-slider-handle': {
      border: 'none',
      backgroundColor: 'transparent',
      fontFamily: 'Ionicons',
      '&::before': {
        position: 'absolute',
        top: '50%',
        left: '50%',
        content: '"\\f21b"',
        color: colorUtils(theme.color.primary)
          .lighten(0.5)
          .string(),
        fontSize: 32,
        transform: 'translate3d(-50%, -50%, 0)'
      },
      '&::after': {
        position: 'absolute',
        top: '50%',
        left: '50%',
        content: '"\\f21b"',
        color: theme.color.primary,
        fontSize: 15,
        transform: 'translate3d(-50%, -50%, 0)'
      }
    },
    '& .rc-slider-rail': {
      backgroundColor: theme.color.basis2
    },
    '& .rc-slider-track': {
      backgroundColor: theme.color.primary
    },
    [theme.mediaQuery.desktopAndUp]: {
      '& .rc-slider-handle': {
        '&::before': {
          fontSize: 24
        },
        '&::after': {
          fontSize: 12
        }
      }
    }
  }),
  ({ disabled }) => ({
    opacity: disabled ? 0.5 : 1
  })
);

const SliderWrapper = styled.div(({ theme }) => ({
  backgroundColor: theme.color.basis6,
  padding: '12px 20px',
  display: 'flex',
  alignItems: 'center',
  color: theme.color.panelAccent,
  height: '55px'
}));

const ContestSlider: React.FC<Props> = ({ disabled, min, max, onChange, value }: Props) => (
  <SliderWrapper>
    <StyledSlider
      disabled={min === max || disabled}
      value={value}
      min={min}
      max={max}
      onChange={onChange}
    />
    <span style={{ paddingLeft: '1em' }}>{value}</span>
  </SliderWrapper>
);

ContestSlider.defaultProps = {
  disabled: false
};

export default ContestSlider;
